// extracted by mini-css-extract-plugin
export default {"alert":"Snackbar_alert__0UMu8","successAlert":"Snackbar_successAlert__O1KfE","errorAlert":"Snackbar_errorAlert__VeTy0","warningAlert":"Snackbar_warningAlert__BNzK1"};